import { ComponentProps } from "react"

export function DocIcon(props: ComponentProps<"img">) {
	return <img
		title={`Скачать DOC(X) файл`}
		style={{ width: "3rem" }}
		src="http://public.kemsu.ru/icons/doc.png"
		{...props}
	/>
}